import { CSSProperties } from "react";

const SkillsCard = ({ title, skills }: SkillsCardProps) => {
  return (
    <div className="anim-skill">
      <h3 className="anim-skill__title">{title}</h3>
      <ul className="anim-skill__list">
        {skills?.map((skill, index) => (
          <li
            key={index}
            className="anim-skill__item"
            style={{ "--anim-delay": `${index * 30}ms` } as CSSProperties}
          >
            {skill}
            {skills.length - 1 !== index && ","}
          </li>
        ))}
      </ul>
    </div>
  );
};
export default SkillsCard;
